<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <h4 class="text-lg font-bold">
    {{ '#TICKETS.DIALOGS.ADD_DOCUMENT.TITLE' | translate }}
  </h4>
  <section class="flex flex-col">
    <div class="flex flex-row card">
      <soft-file-input
        style="width: 100%"
        formControlName="files"
        [progress]="(uploadState$ | async) ?? []"
      ></soft-file-input>
    </div>
  </section>
  <div class="flex flex-row justify-end mt-4">
    <button
      type="submit"
      [disabled]="form.invalid"
      class="soft-button soft-button-primary rounded hover:cursor-pointer"
    >
      {{ '#TICKETS.DIALOGS.ADD_DOCUMENT.SUBMIT' | translate }}
    </button>
  </div>
</form>
